/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AvailableSubscription,
  BackofficeResponse,
  BillingProduct,
  EmbeddableComponentToken,
  HttpRequest,
  HttpResponse,
  MapString,
  PayNowRequest,
  PaymentProfile,
  ProductsStatus,
  SendInvoiceRequest,
  SetupTenantRequest,
  StartTrialResponse,
  SubscriptionModifyInfo,
  TenantInfo,
  TenantMetadata,
  TenantSetupState,
  TenantSubscription,
  TotalLicenses,
  VerificationDeposit,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "billing";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Triggers resyncing of all the mappings. This endpoint will be hidden/secured once service is out of development
   *
   * @tags backoffice
   * @name TriggerTheSyncOfEverything
   * @request POST:/v1/tenant/{tenantId}/backoffice/sync
   * @secure
   */
  triggerTheSyncOfEverything = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      BackofficeResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/backoffice/sync`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for triggerTheSyncOfEverything */
  triggerTheSyncOfEverythingPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/backoffice/sync`);

  /**
   * @description Triggers checking of configuration. This endpoint will be hidden/secured once service is out of development
   *
   * @tags backoffice
   * @name TriggerCheckingOfEverything
   * @request POST:/v1/tenant/{tenantId}/backoffice/configuration-check
   * @secure
   */
  triggerCheckingOfEverything = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      BackofficeResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/backoffice/configuration-check`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for triggerCheckingOfEverything */
  triggerCheckingOfEverythingPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/backoffice/configuration-check`);

  /**
   * @description Start trial for particular product. Customer must already be existing in Chargify.
   *
   * @tags products
   * @name StartTrial
   * @request POST:/v1/tenant/{tenantId}/products/{product}/trial
   * @secure
   */
  startTrial = (tenantId: string, product: BillingProduct, params: RequestParams = {}) =>
    this.request<
      StartTrialResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/products/${product}/trial`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for startTrial */
  startTrialPathGetter = (tenantId: string, product: BillingProduct) =>
    this.getServicePath(`/v1/tenant/${tenantId}/products/${product}/trial`);

  /**
   * @description List all products
   *
   * @tags products
   * @name ListAllProductsWithThierStatusesAndTotalLicenses
   * @request GET:/v1/tenant/{tenantId}/products
   * @secure
   */
  listAllProductsWithThierStatusesAndTotalLicenses = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      ProductsStatus,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/products`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listAllProductsWithThierStatusesAndTotalLicenses */
  listAllProductsWithThierStatusesAndTotalLicensesPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/products`);

  /**
   * @description List total licenses and their counts available for current tenant
   *
   * @tags license
   * @name ListAllLicensesForCurrentTenant
   * @request GET:/v1/tenant/{tenantId}/licenses/total
   * @secure
   */
  listAllLicensesForCurrentTenant = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      TotalLicenses,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/licenses/total`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listAllLicensesForCurrentTenant */
  listAllLicensesForCurrentTenantPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/licenses/total`);

  /**
   * @description Get available subscriptions and components
   *
   * @tags subscriptions
   * @name GetAvailableSubscriptionsAndComponents
   * @request GET:/v1/tenant/{tenantId}/subscriptions/available
   * @secure
   */
  getAvailableSubscriptionsAndComponents = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      AvailableSubscription[],
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/subscriptions/available`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAvailableSubscriptionsAndComponents */
  getAvailableSubscriptionsAndComponentsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/subscriptions/available`);

  /**
   * @description Activates a subscription
   *
   * @tags subscriptions
   * @name ActivatesASubscription
   * @request PUT:/v1/tenant/{tenantId}/subscriptions/{subscriptionId}/activate
   * @secure
   */
  activatesASubscription = (tenantId: string, subscriptionId: number, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/subscriptions/${subscriptionId}/activate`,
      method: "PUT",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for activatesASubscription */
  activatesASubscriptionPathGetter = (tenantId: string, subscriptionId: number) =>
    this.getServicePath(`/v1/tenant/${tenantId}/subscriptions/${subscriptionId}/activate`);

  /**
   * @description Reactives a subscription that is in either trial_ended or cancelled state, according to Maxio docs - https://developers.maxio.com/docs/api-docs/4089be0fa2cb4-reactivate-subscription
   *
   * @tags subscriptions
   * @name ReactivesASubscription
   * @request PUT:/v1/tenant/{tenantId}/subscriptions/{subscriptionId}/reactivate
   * @secure
   */
  reactivesASubscription = (tenantId: string, subscriptionId: number, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/subscriptions/${subscriptionId}/reactivate`,
      method: "PUT",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for reactivesASubscription */
  reactivesASubscriptionPathGetter = (tenantId: string, subscriptionId: number) =>
    this.getServicePath(`/v1/tenant/${tenantId}/subscriptions/${subscriptionId}/reactivate`);

  /**
   * @description Get a subscriptions
   *
   * @tags subscriptions
   * @name GetLicenseSubscriptions
   * @request GET:/v1/tenant/{tenantId}/subscriptions
   * @secure
   */
  getLicenseSubscriptions = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      TenantSubscription[],
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/subscriptions`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getLicenseSubscriptions */
  getLicenseSubscriptionsPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/subscriptions`);

  /**
   * @description Modifies subscription for a license
   *
   * @tags subscriptions
   * @name ModifiesLicenseSubscriptionViaPayNow
   * @request POST:/v1/tenant/{tenantId}/subscriptions/{subscriptionId}/modify/PayNow
   * @secure
   */
  modifiesLicenseSubscriptionViaPayNow = (
    tenantId: string,
    subscriptionId: number,
    data: PayNowRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SubscriptionModifyInfo,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/subscriptions/${subscriptionId}/modify/PayNow`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for modifiesLicenseSubscriptionViaPayNow */
  modifiesLicenseSubscriptionViaPayNowPathGetter = (tenantId: string, subscriptionId: number) =>
    this.getServicePath(`/v1/tenant/${tenantId}/subscriptions/${subscriptionId}/modify/PayNow`);

  /**
   * @description Modifies subscription for a license
   *
   * @tags subscriptions
   * @name ModifiesLicenseSubscriptionViaSendInvoice
   * @request POST:/v1/tenant/{tenantId}/subscriptions/{subscriptionId}/modify/SendInvoice
   * @secure
   */
  modifiesLicenseSubscriptionViaSendInvoice = (
    tenantId: string,
    subscriptionId: number,
    data: SendInvoiceRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SubscriptionModifyInfo,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/subscriptions/${subscriptionId}/modify/SendInvoice`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for modifiesLicenseSubscriptionViaSendInvoice */
  modifiesLicenseSubscriptionViaSendInvoicePathGetter = (tenantId: string, subscriptionId: number) =>
    this.getServicePath(`/v1/tenant/${tenantId}/subscriptions/${subscriptionId}/modify/SendInvoice`);

  /**
   * @description Switches all subscriptions to a remittance mode and clears default payment method
   *
   * @tags subscriptions
   * @name SwitchToRemittance
   * @request POST:/v1/tenant/{tenantId}/subscriptions/switch-to-remittance
   * @secure
   */
  switchToRemittance = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/subscriptions/switch-to-remittance`,
      method: "POST",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for switchToRemittance */
  switchToRemittancePathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/subscriptions/switch-to-remittance`);

  /**
   * @description Switches all subscriptions to a automatic mode
   *
   * @tags subscriptions
   * @name SwitchToAutomatic
   * @request POST:/v1/tenant/{tenantId}/subscriptions/switch-to-automatic
   * @secure
   */
  switchToAutomatic = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/subscriptions/switch-to-automatic`,
      method: "POST",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for switchToAutomatic */
  switchToAutomaticPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/subscriptions/switch-to-automatic`);

  /**
   * @description Setups tenant for billing in external billing platform (Maxio). Is idempotent.
   *
   * @tags setup, fire
   * @name SetupsTenantForBilling
   * @request POST:/v1/tenant/{tenantId}/setup
   * @secure
   */
  setupsTenantForBilling = (tenantId: string, data: SetupTenantRequest, params: RequestParams = {}) =>
    this.request<
      TenantSetupState,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/setup`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for setupsTenantForBilling */
  setupsTenantForBillingPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/setup`);

  /**
   * @description Get info
   *
   * @tags info
   * @name GetInfo
   * @request GET:/v1/tenant/{tenantId}/info
   * @secure
   */
  getInfo = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      TenantInfo,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/info`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getInfo */
  getInfoPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/info`);

  /**
   * @description Reads metadata about tenant
   *
   * @tags metadata
   * @name GetBillingMetadata
   * @request GET:/v1/tenant/{tenantId}/metadata
   * @secure
   */
  getBillingMetadata = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      TenantMetadata,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/metadata`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getBillingMetadata */
  getBillingMetadataPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/metadata`);

  /**
   * @description List all payment profiles attached to tenant
   *
   * @tags payment_profile
   * @name ListAllPaymentProfiles
   * @request GET:/v1/tenant/{tenantId}/payment-profiles
   * @secure
   */
  listAllPaymentProfiles = (
    tenantId: string,
    query?: {
      /** Filter whether card is expired or not */
      expired?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaymentProfile[],
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/payment-profiles`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listAllPaymentProfiles */
  listAllPaymentProfilesPathGetter = (
    tenantId: string,
    query?: {
      /** Filter whether card is expired or not */
      expired?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/payment-profiles`, query);

  /**
   * @description Adds a new payment profile
   *
   * @tags payment_profile
   * @name AddsAPaymentProfile
   * @request POST:/v1/tenant/{tenantId}/payment-profiles/from-chargify/{chargifyJsToken}
   * @secure
   */
  addsAPaymentProfile = (tenantId: string, chargifyJsToken: string, params: RequestParams = {}) =>
    this.request<
      PaymentProfile,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/payment-profiles/from-chargify/${chargifyJsToken}`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for addsAPaymentProfile */
  addsAPaymentProfilePathGetter = (tenantId: string, chargifyJsToken: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/payment-profiles/from-chargify/${chargifyJsToken}`);

  /**
   * @description Verifies a bank payment profile by doing micro deposits
   *
   * @tags payment_profile
   * @name VerifiesABankPaymentProfile
   * @request PUT:/v1/tenant/{tenantId}/payment-profiles/{chargifyBankAccountId}/verify
   * @secure
   */
  verifiesABankPaymentProfile = (
    tenantId: string,
    chargifyBankAccountId: number,
    data: VerificationDeposit,
    params: RequestParams = {},
  ) =>
    this.request<
      PaymentProfile,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/payment-profiles/${chargifyBankAccountId}/verify`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for verifiesABankPaymentProfile */
  verifiesABankPaymentProfilePathGetter = (tenantId: string, chargifyBankAccountId: number) =>
    this.getServicePath(`/v1/tenant/${tenantId}/payment-profiles/${chargifyBankAccountId}/verify`);

  /**
   * @description Get chargify embeddable components token
   *
   * @tags chargify
   * @name GetChargifyAuthToken
   * @request POST:/v1/tenant/{tenantId}/chargify/auth
   * @secure
   */
  getChargifyAuthToken = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      EmbeddableComponentToken,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/chargify/auth`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getChargifyAuthToken */
  getChargifyAuthTokenPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/chargify/auth`);

  /**
   * @description Get the Nue Customer ID
   *
   * @tags nue
   * @name GetTheNueCustomerId
   * @request GET:/v1/nue/tenant/{tenantId}/customer-id
   * @secure
   */
  getTheNueCustomerId = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      string,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/nue/tenant/${tenantId}/customer-id`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getTheNueCustomerId */
  getTheNueCustomerIdPathGetter = (tenantId: string) => this.getServicePath(`/v1/nue/tenant/${tenantId}/customer-id`);

  /**
   * @description Post a request to the Nue proxy
   *
   * @tags nue
   * @name PostARequestToTheNueProxy
   * @request POST:/v1/nue/tenant/{tenantId}/proxy
   * @secure
   */
  postARequestToTheNueProxy = (tenantId: string, data: HttpRequest, params: RequestParams = {}) =>
    this.request<
      HttpResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/nue/tenant/${tenantId}/proxy`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postARequestToTheNueProxy */
  postARequestToTheNueProxyPathGetter = (tenantId: string) => this.getServicePath(`/v1/nue/tenant/${tenantId}/proxy`);

  /**
   * @description Get the Stripe Customer ID
   *
   * @tags nue
   * @name GetTheStripeCustomerId
   * @request GET:/v1/nue/stripe/tenant/{tenantId}/customer-id
   * @secure
   */
  getTheStripeCustomerId = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      string,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/nue/stripe/tenant/${tenantId}/customer-id`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getTheStripeCustomerId */
  getTheStripeCustomerIdPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/nue/stripe/tenant/${tenantId}/customer-id`);

  /**
   * @description Put the Stripe Customer ID
   *
   * @tags nue
   * @name PutTheStripeCustomerId
   * @request PUT:/v1/nue/stripe/tenant/{tenantId}/customer-id
   * @secure
   */
  putTheStripeCustomerId = (tenantId: string, data: string, params: RequestParams = {}) =>
    this.request<
      string,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/nue/stripe/tenant/${tenantId}/customer-id`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putTheStripeCustomerId */
  putTheStripeCustomerIdPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/nue/stripe/tenant/${tenantId}/customer-id`);

  /**
   * @description Post a request to the Stripe proxy
   *
   * @tags nue
   * @name PostARequestToTheStripeProxy
   * @request POST:/v1/nue/stripe/tenant/{tenantId}/proxy
   * @secure
   */
  postARequestToTheStripeProxy = (tenantId: string, data: HttpRequest, params: RequestParams = {}) =>
    this.request<
      HttpResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/nue/stripe/tenant/${tenantId}/proxy`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postARequestToTheStripeProxy */
  postARequestToTheStripeProxyPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/nue/stripe/tenant/${tenantId}/proxy`);

  /**
   * @description Nue webhook
   *
   * @tags nue
   * @name NueWebhook
   * @request POST:/v1/public/nue/webhook
   */
  nueWebhook = (data: any, params: RequestParams = {}) =>
    this.request<void, string | void>({
      path: `/v1/public/nue/webhook`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for nueWebhook */
  nueWebhookPathGetter = () => this.getServicePath(`/v1/public/nue/webhook`);

  /**
   * @description Get a list of Nue Subscription IDs that are relevant for the given tenant
   *
   * @tags nue
   * @name GetNueSubscriptionIDs
   * @request GET:/v1/nue/tenant/{tenantId}/subscription-ids
   * @secure
   */
  getNueSubscriptionIDs = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      string[],
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/nue/tenant/${tenantId}/subscription-ids`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getNueSubscriptionIDs */
  getNueSubscriptionIDsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/nue/tenant/${tenantId}/subscription-ids`);
}
